<template>
<table border="0" cellspacing="0" cellpadding="0">
  <tr class="td-header">
    <td style="width: 50px">序号</td>
    <td style="width: 80px">操作人</td>
    <td style="width: 50px">动作</td>
    <td style="width: 150px">时间</td>
    <td>内容</td>
  </tr>
  <tr v-for="n in 0" :key="n">
    <td class="tc">{{n}}</td>
    <td class="tc">王某某</td>
    <td class="tc">编辑</td>
    <td class="tc">{{new Date().format('yyyy-MM-dd HH:mm:ss')}}</td>
    <td class="p5">灯杆{{n}}增加视频{{n}}</td>
  </tr>
</table>
</template>
<script>
export default {
  name: 'LogsList',
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
  },
}
</script>
<style scoped>
.td-header{
  background: #EAF1F9;
  text-align: center;
  /* height: 38px; */
}
table{
  width: 100%;
}
tr td{
  border-bottom: solid 1px #E9EDF4;
  height: 38px;
}
</style>